import { useQuery } from "@tanstack/react-query";
import { searchAddresses, type AddressSuggestion } from "@/shared/services/address.service";
import { useDebounce } from "./useDebounce";

const ADDRESS_SEARCH_QUERY_KEY = "address-search";
const DEBOUNCE_DELAY = 300;
const MIN_SEARCH_LENGTH = 3;

export const useAddressSearch = (query: string) => {
  const { debouncedValue, isDebouncing } = useDebounce(query, DEBOUNCE_DELAY);

  const shouldSearch = debouncedValue.length >= MIN_SEARCH_LENGTH;

  const { data, isLoading, error } = useQuery<AddressSuggestion[]>({
    queryKey: [ADDRESS_SEARCH_QUERY_KEY, debouncedValue],
    queryFn: () => searchAddresses(debouncedValue),
    enabled: shouldSearch,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    suggestions: data ?? [],
    isLoading: shouldSearch && (isDebouncing || isLoading),
    error,
  };
};
